export default __webpack_public_path__ + "static/media/node.20c94615.jpg";